import { Typography } from '@mui/material';

export const AboutUs = () => {
    return (
        <div style={{ height: 400, width: '80%', margin: "0 auto" }}>
        <Typography sx={{fontSize: "1.5rem", fontWeight: "bold", margin: "20px 0"}}>
            About
        </Typography>
        </div>
    )
}
